import Toast from 'mint-ui/lib/toast';
import 'mint-ui/lib/toast/style.css';

export default Toast;
